import { observable, action, computed } from 'mobx';
import { commonStore, translationsStore } from '.';
import { pick } from 'lodash';

import { api } from '../services';
import moment from 'moment';

class ConnectionRequestsStore {
  @observable connectionRequests = [];
  @observable connectionRequestGroupedByPlate = [];
  @observable isLoading = false;

  constructor(commonStore, translationsStore) {
    this.commonStore = commonStore;
    this.translationsStore = translationsStore;
  }

  @action
  async loadConnectionRequests() {
    this.isLoading = true;
    this.commonStore.loading = true;

    if (!this.commonStore.dealer) {
      await api('dealer profile').then(dealer => {
        commonStore.setDealer(dealer);
      });
    }

    this.retrieveConnectionRequest()
      .finally(() => {
            this.isLoading = false;
            this.commonStore.loading = false;
          });
  }

  @action
  retrieveConnectionRequest() {
    return api('get connection requests', this.commonStore.dealer.masterApiUserUuid)
      .then(connectionRequests => {
        connectionRequests = connectionRequests.map((connectionRequest) => ({
          ...connectionRequest,
          vehicle: { ...connectionRequest.vehicle[0], ...connectionRequest.vehicle[0].node, node: undefined },
        }));
        this.setConnectionRequests(connectionRequests);
      });
  }

  @action
  setConnectionRequests(connectionRequests) {
    this.connectionRequests = connectionRequests;

    this.connectionRequestGroupedByPlate = JSON.parse(JSON.stringify(connectionRequests)).filter((el, index, self) => {
      const firstIndex = self.findIndex(item => item.vehicle.license_plate === el.vehicle.license_plate);
      if( firstIndex === index) {
        return true;
      } else {
        self[firstIndex].product = Array.isArray(self[firstIndex].product)? self[firstIndex].product.push(el.product): [self[firstIndex].product, el.product];
        return false;
      }
    });
  }

  @action
  addConnectionRequest = connectionRequest => {
    const {
      dealer: { masterApiUserUuid: uuid }
    } = this.commonStore;
    let payload = pick(connectionRequest, ['vehicle', 'product_uuid', 'subscription_type_uuid', 'installer_uuid', 'addOns', 'selectedSubscription']);
    payload.vehicle = pick(payload.vehicle, ['vin', 'license_plate', 'brand', 'model', 'variant', 'registration_date', 'fuel_type', 'displacement']);

    if (payload.addOns) {
      payload.addOns = payload.addOns.map(addOn => {return {productUuid: addOn}});
    }

    const selectedSubscription = payload.selectedSubscription;
    delete payload.selectedSubscription;
    if (selectedSubscription && selectedSubscription.products && selectedSubscription.products[0] && selectedSubscription.products[0].portability_reference_contract_uuid) {
      payload.portability_reference_contract_uuid = selectedSubscription.products[0].portability_reference_contract_uuid;

      if(selectedSubscription.products.length > 1) {
        //Putting portability_reference_contract_uuid for blocco motore if present and removing portability
        payload.addOns[0].portability_reference_contract_uuid = selectedSubscription.products[1].portability_reference_contract_uuid;
      }

      payload.addOns.pop();
    }

    return api('postConnectionRequestRegisterVehicle', uuid, payload).then(() => {
      this.retrieveConnectionRequest();
    });
  };

  @observable searchText = '';

  searchTable = request => {
    if (request.vehicle && request.vehicle.license_plate && request.vehicle.license_plate.toLowerCase().includes(this.searchText.toLowerCase())) {
      return true;
    }
    if (request.vehicle && request.vehicle.brand && request.vehicle.brand.name && request.vehicle.brand.name.toLowerCase().includes(this.searchText.toLowerCase())) {
      return true;
    }
    if (request.vehicle && request.vehicle.model && request.vehicle.model.name && request.vehicle.model.name.toLowerCase().includes(this.searchText.toLowerCase())) {
      return true;
    }
    if (
      (request.product && request.product.name && request.product.name.toLowerCase().includes(this.searchText.toLowerCase()))
      || (Array.isArray(request.product) && request.product.map(el=>el.name).some(el=> el.toLowerCase().includes(this.searchText.toLowerCase())) )
    ) {
      return true;
    }
    if (request.vehicle && request.vehicle.installer && request.vehicle.installer.company_name && request.vehicle.installer.company_name.toLowerCase().includes(this.searchText.toLowerCase())) {
      return true;
    }
    if (request.createdAt && moment(request.createdAt).format('DD/MM/YYYY').includes(this.searchText)) {
      return true;
    }
    if (request.subscriptionType && request.subscriptionType.name && this.translationsStore.translate(`connectionRequests.subscriptionType.${request.subscriptionType.name}`).toLowerCase().includes(this.searchText.toLowerCase())) {
      return true;
    }
    return false;
  }

  @computed get filtered() {
    if (this.searchText.length > 0) {
      return this.connectionRequests.filter(request => this.searchTable(request));
    } else {
      return this.connectionRequests;
    }
  }

  @computed get filteredGroupedByPlate() {
    if (this.searchText.length > 0) {
      return this.connectionRequestGroupedByPlate.filter(request => this.searchTable(request));
    } else {
      return this.connectionRequestGroupedByPlate;
    }
  }

  @action
  deleteConnectionRequest(vehicleUuid) {
    this.isLoading = true;

    return api('delete connection request', this.commonStore.dealer.masterApiUserUuid, vehicleUuid)
      .then(() => {

         this.setConnectionRequests(this.connectionRequests.filter(el => !el.vehicle || el.vehicle.uuid !== vehicleUuid));
      })
      .finally(() => {
        this.isLoading = false;
      });
  }

  @action
  subscribeToProducts = async (uuid, connections) => {
    const subscriptions = connections.map(connection => ({
      "licensePlate": connection.vehicle.license_plate,
      "product": {
        "productRatePlanId": connection.rate_plan.id,
        "productUuid": connection.product.uuid
      }
    }))

    return api('subscribeToProducts', uuid, subscriptions);
  }
}

export default new ConnectionRequestsStore(commonStore, translationsStore);



// WEBPACK FOOTER //
// ./src/stores/connectionRequestsStore.js